import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useTranslatedPaginationMessage } from '@/hooks/use-translated-pagination-message'

interface GeneralPaginationProps {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

function GeneralPagination({
  currentPage,
  totalPages,
  onPageChange,
}: GeneralPaginationProps) {
  const translatedPaginationMessage = useTranslatedPaginationMessage({pageIndex: currentPage, pageCount: totalPages});
  return (
    <div className='flex items-center space-x-2'>
      <div className='mr-4 flex text-sm text-muted-foreground'>
        {translatedPaginationMessage}
      </div>
      <Button
        variant='outline'
        size='icon'
        className='mr-1 h-8 w-8 rounded-md'
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
      >
        <ChevronsLeft className='h-4 w-4' />
      </Button>
      <Button
        variant='outline'
        size='icon'
        className='mr-1 h-8 w-8 rounded-md'
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <ChevronLeft className='h-4 w-4' />
      </Button>
      <Button
        variant='outline'
        size='icon'
        className='mr-1 h-8 w-8 rounded-md'
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <ChevronRight className='h-4 w-4' />
      </Button>
      <Button
        variant='outline'
        size='icon'
        className='h-8 w-8 rounded-md'
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
      >
        <ChevronsRight className='h-4 w-4' />
      </Button>
    </div>
  )
}

export default GeneralPagination
